import { useFeatureFlag } from './hooks';

import type { FeatureFlags } from './types';
import type { FC, PropsWithChildren } from 'react';

interface EmptyDataGuardProps extends PropsWithChildren {
  featureKey: FeatureFlags;
}

export const FeatureFlagGuard: FC<EmptyDataGuardProps> = ({
  featureKey,
  children,
}) => {
  const featureFlag = useFeatureFlag(featureKey);

  if (featureFlag) {
    return null;
  }

  return <>{children}</>;
};
